import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/fwhAuth',
    name: 'index',
    component: () => import('@/views/index/index.vue'),
    meta: { title: '服务号绑定' }
  },
  {
    path: '/fl',
    name: 'guide',
    component: () => import('@/views/guide/guide.vue'),
    meta: { title: '违章培训' }
  },
  {
    path: '/rc/:lessonId',
    name: 'rc',
    component: () => import('@/views/rc.vue'),
    meta: { title: '荣昌区交通运输委员会信息公告' }
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: '/fwhAuth/',
  routes
})

// 路由守卫 - 设置页面标题
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
